
import Vue from "vue";
import { Component } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import { UnsplashImage } from "@/lib/ai/types";
import { callImageService } from "@/futurelayer/api/image-bridge";

@Component({
  components: {
    TextInput,
    NiceButton
  }
})
export default class UnsplashImageBrowser extends Vue {
  images: UnsplashImage[] = [];
  unsplashSearchOrientation: "landscape" | "portrait" | "squarish" | null = "landscape";
  unsplashSearchQuery = "";
  loading = false;

  async searchUnsplash() {
    if (!this.unsplashSearchQuery.trim()) return;
    
    this.loading = true;
    try {
      const unsplashResult = await callImageService(
        {
          query: this.unsplashSearchQuery,
          page: 1,
          per_page: 20,
        }
      );

      this.images = unsplashResult;
    } catch (error) {
      console.error("Error searching Unsplash:", error);
      this.images = [];
    } finally {
      this.loading = false;
    }
  }

  selectImage(image: UnsplashImage) {
    this.$emit('image-selected', image);
  }
}
